import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import APP_BASE_URL from '../../components/Api/globalApi';
import { toast } from "react-toastify";
const InstructionCarousel = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [EventAdImages, setEventAdImages] = useState([]);
    // Fetch images on component mount
    useEffect(() => {
        fetchImages();
    }, []);

    useEffect(() => {
        const Adlist = async () => {
            try {
                const response = await axios.post(
                    `${APP_BASE_URL}/ads/list`,
                    {}
                );

                if (response?.data?.result) {
                    console.log(response?.data, 'result')
                    // setAdImages(response.data.data || []);
                    setEventAdImages(response.data.event_data || []);
                } else {
                    toast.error("Failed to load ads");
                }
            } catch (error) {
                console.error(error);
                toast.error("Failed to load ads");
            } finally {
                setLoading(false);
            }
        };
        Adlist();
    }, []);

    // Fetch images from the API
    const fetchImages = async () => {
        setLoading(true);
        setError('');
        setImages([]);

        try {
            // Make POST request to your list API
            const response = await axios.post(
                'https://api.springwayhub.com/mlm/list/instruction',
                {}, // Empty body or add required parameters if needed
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            console.log('Full API Response:', response.data);
            console.log('Response list:', response.data.list);

            // Set the images directly from response.data.list
            if (response.data && response.data.list && Array.isArray(response.data.list)) {
                setImages(response.data.list);
            } else {
                setError('Invalid response format: expected array in response.data.list');
            }
        } catch (err) {
            console.error('API Error:', err);
            setError(
                err.response?.data?.message ||
                err.message ||
                'Failed to fetch instructions'
            );
        } finally {
            setLoading(false);
        }
    };

    // Build complete image URL
    const getImageUrl = (imagePath) => {
        if (!imagePath) return '';

        // If it's already a full URL, return as is
        if (imagePath.startsWith('http')) {
            return imagePath;
        }

        // If it's a relative path, prepend the base URL
        const baseUrl = 'https://api.springwayhub.com/';

        // Remove leading slash if present to avoid double slashes
        const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;

        return baseUrl + cleanPath;
    };

    // Refresh images
    const handleRefresh = () => {
        fetchImages();
    };

    return (
        <div style={styles.container}>

            {/* Loading Indicator */}
            {loading && (
                <div style={styles.loading}>
                    <div style={styles.spinner}></div>
                    Loading images...
                </div>
            )}

            {/* Carousel Section */}
            {!loading && images.length > 0 ? (
                <div style={styles.carouselSection}>
                    <Carousel
                        showArrows={true}
                        showThumbs={false}
                        showStatus={true}
                        infiniteLoop={true}
                        autoPlay={true}
                        interval={5000}
                        dynamicHeight={true}
                        stopOnHover={true}
                        swipeable={true}
                    >
                        {images.map((imageItem, index) => {
                            const imageUrl = getImageUrl(imageItem.im_file);
                            console.log(`Image ${index}:`, imageItem);
                            console.log(`Image URL ${index}:`, imageUrl);

                            return (
                                <div key={index}>
                                    <img
                                        src={imageUrl}
                                        alt={`Instruction ${index + 1}`}
                                        style={styles.image}
                                        onError={(e) => {
                                            console.error('Failed to load image:', imageUrl);
                                            e.target.src = 'https://via.placeholder.com/600x400/cccccc/969696?text=Image+Not+Found';
                                            e.target.alt = 'Image not available';
                                        }}
                                        onLoad={() => console.log(`Image ${index + 1} loaded successfully`)}
                                    />
                                </div>
                            );
                        })}
                    </Carousel>
                </div>
            ) : (
                <div className="carousel-inner text-center">
                    {EventAdImages.map((ad, index) => (
                        <div
                            key={ad.ve_id}
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                        >
                            <img
                                src={
                                    "https://api.springwayhub.com/" + ad.ve_image
                                }
                                alt="specialevents"
                                className="rounded shadow"
                                style={{
                                    width: "100%",
                                    maxWidth: "500px",
                                    height: "auto",
                                    objectFit: "cover",
                                    margin: "0 auto",
                                }}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

// Inline styles (keep your existing styles)
const styles = {
    container: {
        maxWidth: '900px',
        margin: '0 auto',
        padding: '20px',
        fontFamily: 'Arial, sans-serif'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        flexWrap: 'wrap',
        gap: '15px'
    },
    title: {
        color: '#333',
        margin: 0
    },
    refreshButton: {
        background: '#28a745',
        color: 'white',
        padding: '10px 20px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        minWidth: '100px'
    },
    error: {
        background: '#f8d7da',
        color: '#721c24',
        padding: '15px',
        borderRadius: '4px',
        margin: '15px 0',
        border: '1px solid #f5c6cb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px'
    },
    retryButton: {
        background: '#dc3545',
        color: 'white',
        padding: '8px 16px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px'
    },
    loading: {
        textAlign: 'center',
        padding: '40px',
        color: '#007bff',
        fontSize: '18px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px'
    },
    spinner: {
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #007bff',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        animation: 'spin 1s linear infinite'
    },
    noImages: {
        textAlign: 'center',
        padding: '40px',
        color: '#6c757d',
        fontSize: '16px',
        background: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #dee2e6'
    },
    carouselSection: {
        marginTop: '20px'
    },
    subtitle: {
        textAlign: 'center',
        marginBottom: '20px',
        color: '#333',
        fontSize: '18px'
    },
    image: {
        maxHeight: '500px',
        objectFit: 'contain',
        width: '100%',
        borderRadius: '8px'
    },
    legend: {
        background: 'rgba(0, 0, 0, 0.7) !important',
        fontSize: '14px',
        padding: '10px',
        borderRadius: '4px'
    },
    debug: {
        marginTop: '30px',
        padding: '15px',
        background: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        fontSize: '12px'
    },
    debugButton: {
        background: '#6c757d',
        color: 'white',
        padding: '5px 10px',
        border: 'none',
        borderRadius: '3px',
        cursor: 'pointer',
        fontSize: '11px',
        marginBottom: '10px'
    },
    debugPre: {
        margin: 0,
        overflow: 'auto',
        maxHeight: '200px'
    }
};

export default InstructionCarousel;